import { Injectable } from '@angular/core';

@Injectable()
export class PluralizeService{
    private pluralize = require('pluralize');
    constructor() { }
    public Pluralize(noun: string){
        return this.pluralize(noun);
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/util/pluralize.service.ts